import React ,{useEffect, useState}from 'react'
import { Helmet } from 'react-helmet'
import Input from '../../../../../components/Input'
import { getFormattedTime } from '../../../../../util/timeUtility'
import { useTranslation } from 'react-i18next'
import ErrorMessage from './DonationErrorMessage'
import Checkbox from 'antd/es/checkbox/Checkbox'
import Label from '../../../../../components/Label'
import Button from '../../../../../components/Buttons'
import { showNotification } from '../../../../../util/Utility'
import { v4 as uuidv4 } from "uuid";
import axios from 'axios'
import translations from '../translations'

function DonationFormInput({campaign, shareId, platform }) {
    const {t, i18n} = useTranslation()
    const [users, setUserData] = useState({
        name: "",
        email:"",
        amount: "",
        phone:"",
        country_code:""
      });
    const [isButtonDisabled, setIsButtonDisabled] = useState(true)  
    const [isAnonymous, setIsAnonymous] = useState(false)  
    const [isLoading, setIsLoading] = useState(false);
      const [errors, setErrors] = useState({});
    const [currentTranslations, setCurrentTranslations]= useState('EN')

      const handleChangeUser = (keyName, keyValue) => {
        setIsButtonDisabled(false)
        setErrors({})
        let update = { ...users };
        if (keyName === "contact_email") {
          keyValue = keyValue.toLowerCase();
        }
        update[keyName] = keyValue;
        setUserData(update);
      };   

 const isValidEmail = (email)=>{
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    return emailRegex.test(email)
 }

 const isValidAmount = (amount)=>{
    // console.log(Number(amount), Number(campaign?.amount), Number(campaign?.recievedDonation));
    
   return (Number(amount)<= (Number(campaign?.amount) - Number(campaign?.recievedDonation))) && Number(amount)>0 
 }

 const validateBlog = (users) => {
    let isValid = true;
    let message = {};
    // if (!users?.name?.trim()) {
    //   isValid = false;
    //   message["name"] = "name is required";
    // }

    if (!Number.isFinite(users?.amount) && !users?.amount?.trim()) {
      isValid = false;
      message["amount"] = "Amount is required";
    }
    if ( users?.amount?.trim() && !isValidAmount(users?.amount)) {
        isValid = false;
        message["amount"] = "Amount should be less than pending donation and not 0";
      }
    if(users?.amount?.trim() && Number(users?.amount)>1000){
      isValid = false
      message["amount"] = "Members/donors can only donate a maximum of 1000 EUR per transaction";
    }  
    if (users?.phone?.trim() && (users?.phone?.length<4 || users?.phone?.length > 13)) {
        isValid = false;
        message["phone"] = "Enter valid phone number";
      }
    if (users?.email?.trim() && !isValidEmail(users?.email)) {
        isValid = false;
        message["email"] = "Enter valid email address";
      }
    return {
      isValid,
      message,
    };
  };
 
 const handleSubmit = async()=>{
    try {
        setIsLoading(true)
        let check = validateBlog(users);
        
        if(check.isValid){
            console.log("valid data", users);
            let newDonate = { ...users };
        // newDonate.entity_id = entity_id;
        // newDonate.organisation_id = activeEntity.organisation_id;

        const trimmedDetails = {};
        
        for (const key in newDonate) {
          if (typeof newDonate[key] === "string") {
            trimmedDetails[key] = newDonate[key].trim();
          } else {
            trimmedDetails[key] = newDonate[key];
          }
        }
        trimmedDetails.name = trimmedDetails.name || 'Anonymous'
         console.log('valid trimmed', trimmedDetails);
         const payload = {
            paymentMode:'manual',
            paymentId:uuidv4(),
            userId:uuidv4(),
            entityId: campaign?.entity_id,
            campaignId: campaign?._id,
            isAnonymous:false,
            ...trimmedDetails
         }
        sessionStorage.setItem('donationUser', JSON.stringify(trimmedDetails))
        console.log(payload);
        const currentLanguage = i18n.language ? i18n.language.toUpperCase() : 'NL'
          const res = await axios.post(`${process.env.REACT_APP_API_URL}donation/create-transaction?origin=web&shareId=${shareId}&platform=${platform}&formLanguage=${currentLanguage}`,payload);
          console.log(res.data.requiredAction.redirectURL);
          window.open(res?.data?.requiredAction?.redirectURL,"_self")
          setIsLoading(false)  
        }
        else{
            setIsLoading(false)
            setErrors(check.message)
        }
    } catch (error) {
        setIsLoading(false)
        console.log(error);
        showNotification('error',t('some error occured..'))
    }
 }


useEffect(()=>{
  if(sessionStorage.getItem('donationUser')){
    const user = JSON.parse(sessionStorage.getItem('donationUser'))
    console.log('user',user);
    
    setUserData({
      ...users, // Spread the existing user data
      name: user.name === 'Anonymous'?'':user.name,
      email: user.email,
      phone: user.phone,
      amount: user.amount,
      country_code: user.country_code
    });
    setIsButtonDisabled(false)
  }
},[]) 
 
// console.log(currentTranslations,language.toUpperCase(),currentTranslations["email is required"] );

  return (
    <div className="add_form donation-form-input" style={{padding:'25px'}} >
      <Helmet>
        <title>Mosqapp</title>
      </Helmet>
      <div className="mosque-form" >
        {/* <h2>Add Member</h2> */}
        <div className="row">
          <div className="col-lg-6 input-width add-input-field-margin">
            <label mb="8px">
              {t('Full Name')}
            </label>
            <input
              value={users?.name}
              onChange={(e) => handleChangeUser("name", e.target.value)}
              type="text"
              placeholder={t("Enter Name")}
              className="input-box"
            />
            {errors.name && (
              <ErrorMessage>{t(errors.name)}</ErrorMessage>
            )}
          </div>
          <div className="col-lg-6 input-width add-input-field-margin">
            <label mb="8px" isMandatory>
              {t("Email Address")} 
            </label>
            <input
            //   onBlur={() => handleEmailAndPhoneValidation()}
              value={users?.email}
              onChange={(e) =>
                handleChangeUser("email", e.target.value)
              }
              type="text"
              placeholder={t("Enter Your Email Address")}
              className="input-box"
            //   disabled={isToBeApproved}
            />
            {errors.email && (
              <ErrorMessage>{t(errors.email)}</ErrorMessage>
            )}
          </div>
          <div className="col-lg-6 pt-2 input-width add-input-field-margin">
            <label mb="8px" >
              {t("Contact Number")} 
            </label>
            <Input
            //   onBlur={() => handleEmailAndPhoneValidation()}
              value={users?.phone}
              countryCodes={true}
              countryCodeValue={users?.country_code}
              setCountryCode={(e) => handleChangeUser("country_code", e)}
            //   isDisabled={isToBeApproved}
              onChange={(e) =>
                handleChangeUser("phone", e.target.value)
              }
              border={users?.phone?.length ? "1px solid #606734" : null}
              placeholder="785-785-464"
              className="input-box"
              type="number"
              pattern="[0-9]"
              height="52px"
              overflow="unset"
            />
            {errors.phone && (
              <ErrorMessage>{t(errors.phone)}</ErrorMessage>
            )}
          </div>
            
          <div className="col-lg-6 pt-4">
            <label>
              {t("Amount")}
              <span style={{ color: "#FE1717" }}>*</span>
            </label>
            <Input
              value={users?.amount}
              onChange={(e) => handleChangeUser("amount", e.target.value)}
              type="number"
              placeholder={t("Enter Amount")}
              className="input-box"
            />
            {errors?.amount ? (
              <ErrorMessage>{t(errors?.amount)}</ErrorMessage>
            ) : null}
          </div>
          <div style={{display:'flex', gap:'5px',alignItems:'center', marginTop:'15px'}}>
          {/* <Checkbox  value={isAnonymous} onChange={()=>setIsAnonymous(!isAnonymous)}/> */}
          {/* <label style={{fontSize:'12px', color:'#1a1a1a',}}>{t('Make my donation anonymous')}</label> */}
          </div>
          <Button  type={(isButtonDisabled || isLoading) ? "disabled" : "primary"} onClick={handleSubmit}  width="132px" margin="0 auto">{t('Donate Now')}</Button>
          </div>
      </div>
      </div>
  )
}

export default DonationFormInput